import * as elog from '@reverbdotcom/commons/src/elog';

import {
  Core_Checkout_SetAccertifyTokensMutation,
  Core_Checkout_SetAccertifyTokensMutationVariables,
  CheckoutFraudSetupHookFieldsFragment,
  core_apimessages_AccertifyDeviceInfo,
} from '@reverbdotcom/commons/src/gql/graphql';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';
import { gql } from '@reverbdotcom/commons/src/gql';
import window from '@reverbdotcom/commons/src/window_wrapper';

export function buildDeviceInfoPayload(): core_apimessages_AccertifyDeviceInfo {
  if (!window._bcn) {
    return {};
  } else {
    return {
      transactionId: window._bcn.dvc?.getTID() || '',
      ubaId: window._bcn.getToken(),
      ubaEvents: window._bcn.getEvents(),
      pageId: String(window._bcn.getPageId()),
      ubaSessionId: window._bcn.getUbaSessionId(),
    };
  }
}

export function useCheckoutFraudSetup(checkout: CheckoutFraudSetupHookFieldsFragment, loadAccertifyJs = false) {
  const [mutate, { loading }] = useMutation<
      Core_Checkout_SetAccertifyTokensMutation,
      Core_Checkout_SetAccertifyTokensMutationVariables
    >(
      SET_ACCERTIFY_TOKENS,
    );

  async function setupFraudCheck() {
    if (!loadAccertifyJs) { return; }
    if (!window._bcn) {
      elog.info('checkout.setupFraudCheck.js_not_loaded', { checkout_id: checkout.id });
      return;
    }

    try {
      window._bcn.flush();

      const response = await mutate({
        variables: {
          input: {
            checkoutId: checkout.id,
            accertifyDeviceInfo: buildDeviceInfoPayload(),
          },
        },
      });

      if (response.errors?.length) {
        throw new Error(response.errors.map(e => e.message).join('; '));
      }
    } catch (e) {
      elog.error('checkout.setupFraudCheck.error', {}, e);
    }

    return;
  }

  return {
    setupFraudCheck,
    loading,
  };
}

export const CheckoutFraudSetupHookFragment = gql(`
  fragment CheckoutFraudSetupHookFields on Checkout {
    _id
    id
  }
`);

export const SET_ACCERTIFY_TOKENS = gql(`
  mutation Core_Checkout_SetAccertifyTokens(
    $input: Input_core_apimessages_SetAccertifyTokensRequest
  ) {
    setAccertifyTokens(input: $input) {
      id
    }
  }
`);
